/* eslint-disable import/prefer-default-export */
export const MIME_TYPES = {
  flac: 'audio/flac',
};
